import React from 'react';
import PageTemplate from '../components/PageTemplate';

const Careers = () => {
  return (
    <PageTemplate
      title="Careers"
      subtitle="Join our team and shape the future of technology"
      breadcrumb="Careers"
    >
      <div className="content-section">
        <h2>Work With Us</h2>
        <p>We're always looking for talented individuals to join our growing team. If you're passionate about technology and innovation, we'd love to hear from you.</p>
        <div className="cta-section">
          <h3>Interested in Joining Our Team?</h3>
          <p>Send your resume and portfolio to our HR team.</p>
          <a href="mailto:careers@codes-ai.com" className="btn btn-primary">Send Your Resume</a>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Careers; 